<template>
  <b-container v-if="loaded" fluid>
    <b-row>
      <b-col class="mt-3">
        <b-alert variant="danger" dismissible :show="showAlert" @dismissed="showAlert=false">
          {{ alertMessage }}
        </b-alert>

        <b-row>
          <b-col>
            <b-table striped :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="unconnected" :fields="fields" @row-clicked="rowClickedHandler">
              <template #cell(buttons)="row">
                <b-button-group align="right">
                  <b-button size="sm" variant="primary" @click.stop="modalConfigureOpen(row.item, row.index, $event.target)" class="mr-1">
                    Configure
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal id="modalConfigure" @hide="modalConfigureReset" :title="modalConfigure.title" ok-variant="primary" @ok="configure()">
      <b-form>
        <b-form-input id="host" type="text" v-model="form.host" hidden></b-form-input>
        <b-form-input id="options" type="text" v-model="form.options" hidden></b-form-input>

        <b-form-group label="Type">
          <!-- <b-form-input id="type" type="text" v-model="form.type"></b-form-input> -->
          <b-form-select v-model="form.type" :options="typeOptions"></b-form-select>
        </b-form-group>

      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';
import formatter from './formatter.mixin.js';

export default {
  name: 'unconnected',
  components: {
  },
  props: ['settings'],
  mixins: [formatter],
  data() {
    return {
      typeSelected: null,
      typeOptions: [
        { text: 'Analog', value: 'analog' },
        { text: 'Arkel', value: 'arkel' },
        { text: 'DAC', value: 'mec32' },
        { text: 'DMG', value: 'dmg' },
        { text: 'FST', value: 'fst' },
        { text: 'Imem', value: 'imem' },
        { text: 'Kinetek', value: 'kinetek' },
        { text: 'Kollmorgen (UART)', value: 'mpk' },
        { text: 'Kollmorgen (TCP/IP)', value: 'mpktcp' },
        { text: 'Kollmorgen (Websocket)', value: 'kollmorgen' },
        { text: 'Kone', value: 'kone' },
        { text: 'Mikel', value: 'mikel' },
        { text: 'Oleva 93-20', value: 'mikel' },
        { text: 'Orona Arca II', value: 'arca' },
        { text: 'Otis', value: 'otis' },
        { text: 'RST', value: 'rst' },
        { text: 'Schindler 3100', value: 'schindler3100' },
        { text: 'Schindler 3300', value: 'schindler3300' },
        { text: 'Schindler BX', value: 'schindlerBX' },
        { text: 'Schindler MXGC', value: 'mxgc' },
        { text: 'Schindler', value: 'schindler' },
        { text: 'Thyssen MCI', value: 'thyssen' },
        { text: 'Thyssen TCI', value: 'tci' },
        { text: "Thyssen CMC4", value: "cmc4" },
        { text: "Böhnke", value: "bohnke" },
      ],
      loaded: false,
      loggedIn: auth.loggedIn(),
      modalConfigure: { title: '' },
      sortBy: 'status',
      sortDesc: false,
      unconnected: [],
      showAlert: false,
      alertMessage: '',
      fields: [
        { 
          key: 'host',
          label:'SN',
          sortable: true,
        },
        { 
          key: 'status',
          label: 'Status',
          sortable: false,
          formatter: (value, key, item) => {
              return this.elevatorConfigStatusFormatter(value);
          }
        },
        { 
          key: 'type',
          label: 'Brand',
          sortable: true,
          formatter: (value, key, item) => {
            if(value) {
              return this.elevatorTypeFormatter(value);
            } else {
              return '';
            }
          }
        },
        { 
          key: 'buttons',
          label: '',
          sortable: false,
        },
      ],
      form: {
        host: "",
        type: "",
        options: "",
      },
    }
  },
  methods: {
    rowClickedHandler(record, index) {
      //this.$router.push({ name: 'elevator', params: { 'id': record.id } })
    },
    modalConfigureReset() {
      this.form.host = '';
      this.form.type = '';
      this.form.options = '';
    },
    configure () {
      this.showAlert = false;
      this.alertMessage = '';
      api.updateUnconnected(this.form.host, this.form.type, this.form.options, response => {
        if(response.data == "OK") {
          this.getUnconnected();
          this.form.host = '';
          this.form.type = '';
          this.form.options = '';
        } else {
          this.alertMessage = response.data;
          this.showAlert = true;
        }
      });
    },
    getUnconnected() {
      api.getUnconnected(unconnected => {
        if(unconnected.data) {
          this.unconnected = unconnected.data;
          this.loaded = true;
        } else {
          this.unconnected = [];
          this.loaded = false;
        }
      });
    },
    modalConfigureOpen(item, index, button) {
      this.modalConfigure.title = item.host;
      this.form.host = item.host;
      this.$root.$emit('bv::show::modal', 'modalConfigure', button);
    },
  },
  computed: {
  },
  created() { 
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
      this.getUnconnected();
    }
    this.getUnconnected();

    if(this.settings.refresh) {
      this.refreshTimer = setInterval(this.refresh, parseInt(this.settings.refresh));
    } else {
      this.refreshTimer = setInterval(this.refresh, 30000);
    }
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
}
</script>

<style>
tr {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Unconnected.vue